module.exports = __webpack_public_path__ + "img/hallType2.c2425569.png";